import {inject, Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor
} from '@angular/common/http';
import {catchError, EMPTY, throwError as observableThrowError} from 'rxjs';
import {SessionService} from "../services/session.service";
import {ToastService} from '../services/toast.service';

@Injectable()
export class ApiRequestInterceptor implements HttpInterceptor {
  private readonly sessionService = inject(SessionService);
  private readonly toastService = inject(ToastService);

  intercept(req: HttpRequest<any>, next: HttpHandler): any {
    return next.handle(req)
      .pipe(
        catchError(async err => {
          switch (err && err.status) {
            case 401:
              if (this.isValidRedirect())
                await this.sessionService.Logout();
              return EMPTY;
            case 400:
            case 500:
              const message = err?.error.description ?? err?.error.Message ?? 'Something went wrong.';
              this.toastService.showToast(message, 'error');
              throw err;
            default:
              break;
          }
          return observableThrowError(err);
        }));
  }

  isValidRedirect() {
    const url = window.location.href;
    return !url.includes('complete-registration');
  }
}
